import React from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const FeatureCard = ({ dashboardData, period }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  console.log(dashboardData,"fffffff")
  const data = [
    {
      label: t("dashboard.upcommingList"),
      value: dashboardData?.upcomingBookings || 0,
    },
    // {
    //   label: t("dashboard.completetedBookings"),
    //   value: dashboardData?.completedBookings || 0,
    // },
    {
      label: t("dashboard.totalBookings"),
      value: `${dashboardData?.totalBookings || 0}`,
    },
    {
      label: t("dashboard.cancelledBookings"),
      value: `${dashboardData?.totalCancelledBookings || 0}`,
    },
    //  {
    //   label: t("dashboard.todayBookings","Today Bookings"),
    //   value: `${dashboardData?.todayBookings || 0}`,
    // },
    // {
    //   label: t("dashboard.todayCancelledBookings","Today Cancelled Bookings"),
    //   value: `${dashboardData?.todayCancelledBookings || 0}`,
    // },
    //  {
    //   label: t("dashboard.expiredBookings"),
    //   value: `${dashboardData?.expiredBookings || 0}`,
    // },
    ...(period === "yesterday" ?
      [
      //   {
      //   label: t("dashboard.yesterdayBooked"),
      //   value: dashboardData?.yesterdayBooked || 0,
      // },
      // {
      //   label: t("dashboard.yesterdayRevenue"),
      //   value: `${dashboardData?.yesterdayRevenue || 0}`,
      // }
    ]
      : period === "thisWeek" ?
        [{
          label: t("dashboard.thisWeekBooked"),
          value: dashboardData?.thisWeekBooked || 0,
        },
        {
          label: t("dashboard.thisWeekRevenue"),
          value: `${dashboardData?.thisWeekRevenue || 0}`,
        }] : period === "thisMonth" ?
          [{
            label: t("dashboard.thisMonthBooked"),
            value: dashboardData?.thisMonthBooked || 0,
          },
          {
            label: t("dashboard.thisMonthRevenue"),
            value: `${dashboardData?.thisMonthRevenue || 0}`,
          }]
          : period === "lastMonth" ?
            [{
              label: t("dashboard.lastMonthBooked"),
              value: dashboardData?.lastMonthBooked || 0,
            },
            {
              label: t("dashboard.lastMonthRevenue"),
              value: `${dashboardData?.lastMonthRevenue || 0}`,
            }] : period === "all" ?
              [{
                label: t("dashboard.totalAllBooked"),
                value: dashboardData?.totalBooking || 0,
              },
              {
                label: t("dashboard.totalAllRevenue"),
                value: `${dashboardData?.totalRevenue || 0}`,
              }]
              : [])
    ,
    // {
    //   label: t("dashboard.totalRevenue", "Total Revenue"),
    //   value: dashboardData?.totalRevenue || 0
    //   // `${period === "all"
    //   //   ? dashboardData?.totalRevenue
    //   //   : dashboardData?.todayRevenue +
    //   //     period === "yesterday"
    //   //     ? dashboardData?.yesterdayRevenue
    //   //     : period === "thisWeek"
    //   //       ? dashboardData?.thisWeekRevenue
    //   //       : period === "thisMonth"
    //   //         ? dashboardData?.thisMonthRevenue
    //   //         : period === "lastMonth"
    //   //           ? dashboardData?.lastMonthRevenue
    //   //           : 0
    //   //           || 0}`
                
    // },
    // {
    //   label: t("dashboard.todayRevenue", "Today Revenue"),
    //   value: dashboardData?.todayRevenue || 0}
  ];

  return (
    <>
      <Row>
        {data &&
          data?.length > 0 &&
          data?.map((item, key) => (
            <Col
              key={key}
              lg="4"
              md="4"
              sm="6"
              className="my-2"
              onClick={() => navigate(item.redirectPath)}
              style={{ cursor: "pointer" }}
            >
              <div
                className="cardCstm rounded p-3 py-lg-4 d-flex align-items-center gap-10"
                style={{
                  background: "#e8307a21",
                  borderRadius: "5px",
                }}
              >
                <div className="content">
                  <h6
                    className="m-0 fw-bold py-1 text-dark"
                    style={{ fontSize: "14px" }}
                  >
                    {item.label}
                  </h6>
                  <h4 className="m-0 fw-bold themeBlue py-1">{item.value}</h4>
                </div>
              </div>
            </Col>
          ))}
      </Row>
    </>
  );
};

export default FeatureCard;
